import React from "react";

import { AttributeCardDisplayVariantType } from "../types";

import AttributeSelectionCard from "@/Components/PersonalAttributes/Components/AttributeSelectionCard";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  RolePosition,
  UserRoleAttributeSet,
} from "@/schemas/profile/attributes/UserRoleAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type RoleSelectionProps = {
  session: AppUserSession;
  roleValue: RolePosition | null;
  variant: AttributeCardDisplayVariantType;
};

function RoleSelection({
  session,
  roleValue,
  variant,
}: RoleSelectionProps): React.JSX.Element {
  const values = roleValue ? [UserRoleAttributeSet.map[roleValue]] : [];
  const typedValues = values.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <AttributeSelectionCard
      session={session}
      attribute={UserRoleAttributeSet}
      values={typedValues}
      icon={"🔥"}
      variant={variant}
      fullWidth={variant === AttributeCardDisplayVariantType.ONBOARDING}
    />
  );
}

export default RoleSelection;
